import { render } from "./FriEs.vue?vue&type=template&id=292946f8"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/FriEs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "292946f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('292946f8', __exports__)) {
    api.reload('292946f8', __exports__)
  }
  
  module.hot.accept("./FriEs.vue?vue&type=template&id=292946f8", () => {
    api.rerender('292946f8', render)
  })

}


export default __exports__